module.exports = __webpack_public_path__ + "img/logo-dark.bd1e537b.png";